import { createActions, createReducer } from 'reduxsauce'

export const { Types, Creators } = createActions(
	{
		setProviderSignupData: ['providerSignupData'],
	},
	{
		prefix: 'authentication/',
	}
)

const initialState = {
	providerSignupData: null,
}
const setProviderSignupData = (
	state = initialState,
	{ providerSignupData }
) => ({
	...state,
	providerSignupData,
})

export default createReducer(initialState, {
	[Types.SET_PROVIDER_SIGNUP_DATA]: setProviderSignupData,
})
